import axios from "axios";
import React from "react";
import { getRequest } from "./QuoteApiService";

export const getQuoteAddLookups = ( tenantId) => {
  const call = getRequest('GetQuoteAddLookups/' + tenantId);

  console.log("Services > getQuoteAddLookups called...");

  return new Promise((resolve, reject) => {
    try {
      axios
      .all([call])
      .then((res) => {
        console.log("getQuoteAddLookups > axios res=", res);
        resolve(res);
      })
      .catch((err) => {
        console.log("getQuoteAddLookups > axios err=", err);
        reject("Error in getQuoteAddLookups axios!");
      });
    } catch (error) {
      console.error("in services > getQuoteAddLookups, Err===", error);
      //reject(SYSTEM_ERROR);
    }
  });
  
}
